import { render, staticRenderFns } from "./typeParaistaireActions.vue?vue&type=template&id=5a38ca95"
import script from "./typeParaistaireActions.vue?vue&type=script&lang=js"
export * from "./typeParaistaireActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports